import * as React from "react"
import dynamic from "next/dynamic"
import classnames from "classnames"
import benefitsStyles from "../../../styles/components/Product/Benefits/Benefits-tw-styles"
import RichText from "../RichText/Richtext"
import Carousel from "../../Carousel"
const BackgroundImage = dynamic(() => import("../../BackgroundImage"))
const Video = dynamic(() => import("../Video/Video"))
import { breakpoints } from "../../../constants/global"
import Disclaimer from "../Disclaimer/Disclaimer"
import Typography from "../Typography/Typography"
import PropTypes from "prop-types"
import Button from "../../../components/Button/Button"
import { getImageUrl, getSrcSet } from "../../../adapters/cloudinary.adapters"
const Hammer = typeof window != "undefined" ? require('hammerjs') : ""

class Benefits extends React.Component {
    constructor(props) {
        super(props)
        this.benefitSection = props.content
        this.benefitData = this.benefitSection.benefitsCollection
        this.benefitsCount = this.benefitData.items.length
        this.mediaRefs = []
        this.nameRefs = []
        this.carouselRef = null
        this.benefitRef = null
        if (typeof window != "undefined") {
            this.windowWidth = window.innerWidth
        }
        this.flickityOptions = {
            cellAlign: "left",
            pageDots: false,
            selectedAttraction: 0.2,
            friction: 0.9,
            dragThreshold: 1
        }
        this.state = {
            currentIndex: 0
        }
    }

    setMediaRef = (ref, index) => {
        this.mediaRefs[index] = ref
    }

    setNameRef = (ref, index) => {
        this.nameRefs[index] = ref
    }

    setBenefitRef = (ref) => {
        this.benefitRef = ref
    }

    setCarouselRef = flickityObj => {
        this.carouselRef = flickityObj
        this.carouselRef.resize()
        this.carouselRef.on("settle", index => {
            this.handleClick(index)
        })
    }

    addSwipe = () => {
        const { benefitRef, isChild } = this
        const styles = benefitsStyles[this.benefitSection.styles || 'default'] || benefitsStyles['default']
        const { nameSection } = styles
        const benefitNamesUniqueClass = nameSection.split(' ')[0]
        if (Hammer && benefitRef) {
            const hammerInst = new Hammer.Manager(benefitRef, {
                recognizers: [
                    [Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }],
                ]
            })
            const benefitNamesElem = document.querySelector(`.${benefitNamesUniqueClass}`)
            hammerInst.on("swiperight", e => {
                if (!isChild(benefitNamesElem, e.target)) {
                    this.carouselRef.previous()
                }
            })
            hammerInst.on("swipeleft", e => {
                if (!isChild(benefitNamesElem, e.target)) {
                    this.carouselRef.next()
                }
            })
        }
    }

    isChild = (parent, child) => {
        return parent !== child && parent.contains(child)
    }

    getBenefitMedia = (media, index) => {
        const styles = benefitsStyles[this.benefitSection.styles || 'default'] || benefitsStyles['default']
        const { backgroundImage, video } = styles
        const { setMediaRef } = this
        switch (media.__typename) {
        case "ImageSet":
            return (
                <BackgroundImage
                    className={classnames(backgroundImage, {
                        "is-selected": index === 0
                    })}
                    setImageRef={ref => setMediaRef(ref, index)}
                    lazyLoad={true}
                    tag='div'
                    image={media}
                    key={media.sys.id}
                ></BackgroundImage>
            )
        case "Videos":
            return (
                <Video
                    classKey={classnames(video, {
                        "is-selected": index === 0
                    })}
                    setVideoRef={(ref) => setMediaRef(ref, index)}
                    videoData={media}
                    lazyLoad={true}
                    key={media.sys.id}
                />
            )
        default:
        }
    }

    handleClick = currentIndex => {
        this.setState({ currentIndex })
    }

    changeSelected = (refs, prevIndex, currIndex) => {
        const prevEl = refs[prevIndex]
        const currEl = refs[currIndex]
        prevEl.classList.remove("is-selected")
        currEl.classList.add("is-selected")
    }

    playVideo = video => {
        if (video && video.paused) {
            video.play()
            video.onended = () => {
                video.play()
            }
        }
    }

    getBenefitNames = () => {
        const { benefitData, handleClick, setNameRef, windowWidth, carouselRef, benefitsCount } = this
        const styles = benefitsStyles[this.benefitSection.styles || 'default'] || benefitsStyles['default']
        const { name, singleBenefit } = styles
        return benefitData.items.map((benefit, index) => (
            benefit.name && <Typography
                component={this.benefitSection.title ? 'h3' : 'h2'}
                className={classnames(name, { "is-selected": index === 0 }, { [singleBenefit]: benefitsCount === 1 })}
                setTypoRef={(ref) => setNameRef(ref, index)}
                tabIndex={ benefitsCount > 1 ? 0 : '-1'}
                role='button'
                onClick={() => windowWidth < breakpoints.sP && benefitsCount > 1 ? carouselRef.select(index) : handleClick(index)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        handleClick(index)
                    }
                }}
                key={index}
            >
                {benefit.name}
            </Typography>
        ))
    }

    sectionClickHandler = (e) => {
        const { windowWidth, carouselRef, isChild, benefitRef, benefitsCount } = this
        const styles = benefitsStyles[this.benefitSection.styles || 'default'] || benefitsStyles['default']
        const { nameSection } = styles
        const benefitNamesUniqueClass = nameSection.split(' ')[0]
        const benefitNamesElem = document.querySelector(`.${benefitNamesUniqueClass}`)
        if (typeof window !== "undefined" && windowWidth < breakpoints.sP && benefitsCount > 1 && !isChild(benefitNamesElem, e.target)) {
            const pWidth = benefitRef.offsetWidth
            pWidth / 2 > e.pageX ? carouselRef.previous() : carouselRef.next()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            state: { currentIndex },
            props: { scrollMagicEvent },
            mediaRefs,
            nameRefs,
            changeSelected,
            windowWidth,
            playVideo,
            benefitsCount
        } = this
        const { currentIndex: prevIndex } = prevState
        if (currentIndex != prevState.currentIndex) {
            changeSelected(mediaRefs, prevIndex, currentIndex)
            if (windowWidth >= breakpoints.sP || benefitsCount === 1) {
                changeSelected(nameRefs, prevIndex, currentIndex)
            }
        }

        if (
            currentIndex != prevState.currentIndex ||
            (scrollMagicEvent && scrollMagicEvent.type === "start" && prevProps.scrollMagicEvent.timestamp != scrollMagicEvent.timestamp)
        ) {
            const currentMedia = mediaRefs[currentIndex]
            if (currentMedia && currentMedia.tagName === "VIDEO") {
                playVideo(currentMedia)
            }
            if (currentIndex != prevState.currentIndex) {
                window.dataLayer.push({
                    event: 'customEvent',
                    GAeventCategory: 'event_informational_action',
                    GAeventAction: 'event_view_more_details',
                    GAeventLabel: `Benefit Carousel_${currentIndex + 1}`
                })
            }
        }
    }

    componentDidMount() {
        const { windowWidth, addSwipe, benefitsCount } = this
        if (windowWidth < breakpoints.sP && benefitsCount > 1) {
            addSwipe()
        }
    }

    render() {
        const styles = benefitsStyles[this.benefitSection.styles || 'default'] || benefitsStyles['default']
        const { Benefits: benefitsStyle, mediaItems, nameSection, description, title, textWrapper, gradientOverlay, disclaimer, black, imgStyle } = styles
        const {
            benefitData,
            getBenefitMedia,
            windowWidth,
            flickityOptions,
            getBenefitNames,
            setCarouselRef,
            setBenefitRef,
            benefitSection,
            benefitsCount,
            sectionClickHandler,
            state: { currentIndex }
        } = this
        let themeKey = ""
        if (benefitSection.mobileThemeColor && windowWidth < breakpoints.sP) {
            themeKey = benefitSection.mobileThemeColor
        } else if (benefitSection.themeColor) {
            themeKey = benefitSection.themeColor
        }
        const theme = themeKey ? styles[themeKey] : black
        return (
            <div role='presentation' className={classnames(benefitsStyle, theme)} ref={(ref) => setBenefitRef(ref)} onClick={sectionClickHandler}>
                <div className={mediaItems}>
                    {benefitData.items[0].media && this.benefitSection.uniqueImage ?
                        <picture>
                            <source
                                src={getImageUrl(benefitData.items[0].media.desktopImage.url)}
                                srcSet={getSrcSet(benefitData.items[0].media.desktopImage.url, 1024)} media='(min-width:1024px)' />
                            <img className={imgStyle ? imgStyle : ''} src={getImageUrl(benefitData.items[0].media.smartphoneImage.url)} alt={benefitData.items[0].media.altText} />
                        </picture> :
                        benefitData.items.map(
                            (benefit, index) =>
                                benefit.media &&
                                getBenefitMedia(benefit.media, index)
                        )}
                </div>
                <div className={gradientOverlay}></div>

                <div className={textWrapper}>
                    {benefitSection.title && (
                        <Typography component={benefitSection?.headingType || 'h2'} className={title}>{benefitSection.title}</Typography>
                    )}
                    <div className={nameSection}>
                        {windowWidth < breakpoints.sP && benefitsCount > 1 ? (
                            <Carousel
                                options={flickityOptions}
                                className={"slider"}
                                flickityRefCallback={ref => setCarouselRef(ref)}
                            >
                                {getBenefitNames()}
                            </Carousel>
                        ) : (
                            getBenefitNames()
                        )}
                    </div>
                    {benefitData.items[currentIndex].description && (
                        <RichText
                            className={description}
                            richTextJson={benefitData.items[currentIndex].description}
                            key={currentIndex}
                        />
                    )}
                    {benefitData.items[currentIndex].disclaimer && (
                        <Disclaimer
                            classKey={disclaimer}
                            theme={themeKey}
                            content={benefitData.items[currentIndex].disclaimer}
                        />
                    )}
                    {benefitData?.items[currentIndex]?.cta &&
                        <Button
                            href={benefitData.items[currentIndex]?.cta?.link}
                            className='how-to-use-btn'
                        >
                            {benefitData.items[currentIndex]?.cta?.linkText}
                        </Button>
                    }
                </div>
            </div>
        )
    }
}
Benefits.propTypes = {
    content: PropTypes.object,
    scrollMagicEvent: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
}
export default Benefits
